import { render, staticRenderFns } from "./ICSCenterMenu.vue?vue&type=template&id=e38d1ad0&scoped=true&"
import script from "./ICSCenterMenu.vue?vue&type=script&lang=js&"
export * from "./ICSCenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ICSCenterMenu.vue?vue&type=style&index=0&id=e38d1ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38d1ad0",
  null
  
)

export default component.exports